import { createSlice } from '@reduxjs/toolkit';
import { ContactState } from '@/types/contact';
import { contact } from './thunks';

const initialState: ContactState = {
  contacts: [],
  currentContact: null,
  isLoading: false,
  error: null,
  totalCount: 0,
};

export const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    clearError: state => {
      state.error = null;
    },
    clearCurrentContact: state => {
      state.currentContact = null;
    },
  },
  extraReducers: builder => {
    builder
      // Get Contacts
      .addCase(contact.getContacts.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(contact.getContacts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.contacts = action.payload;
        state.totalCount = action.payload.length;
      })
      .addCase(contact.getContacts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Create Contact
      .addCase(contact.createContact.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(contact.createContact.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.contacts.push(action.payload);
        state.totalCount += 1;
      })
      .addCase(contact.createContact.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Get Contact
      .addCase(contact.getContact.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(contact.getContact.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.currentContact = action.payload;
      })
      .addCase(contact.getContact.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Update Contact
      .addCase(contact.updateContact.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(contact.updateContact.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        const index = state.contacts.findIndex(contact => contact.id === action.payload.id);
        if (index !== -1) {
          state.contacts[index] = action.payload;
        }
        if (state.currentContact?.id === action.payload.id) {
          state.currentContact = action.payload;
        }
      })
      .addCase(contact.updateContact.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Delete Contact
      .addCase(contact.deleteContact.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(contact.deleteContact.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.contacts = state.contacts.filter(contact => contact.id !== action.payload);
        state.totalCount -= 1;
        if (state.currentContact?.id === action.payload) {
          state.currentContact = null;
        }
      })
      .addCase(contact.deleteContact.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, clearCurrentContact } = contactSlice.actions;
export const contactReducer = contactSlice.reducer;
